import { Controller } from 'front-end-core/core/Router'
import Main from 'pages/comments/Main'
import getUrl from 'front-end-core/core/url'
import { COMMENTS } from 'constants/controllers'
import Header from './Header'

export default new Controller({
  name: COMMENTS,
  route: '(:aol/)annotations',
  controller (Router, { query, params: { aol } }, render) {
    const pageId = getUrl(COMMENTS)
    const { category } = query

    render(
      { Main, Header },
      {
        query
      },
      {
        pageId,
        searchType: category === 'legislation' ? 'legislation' : 'qa',
        className: `comments ${category}`,
        aol
      }
    )

    return pageId
  }
})
